import { api } from '@/core/api/'

const apiUrl = 'api/edenpersonnel'

export default {
  getReportAvailableAcademicYears() {
    return api.get(`${apiUrl}/reportavailableacademicyears`)
  },
  getAvailableAcademicYears() {
    return api.get(`${apiUrl}/availableAcademicYears`)
  },
  getSummary(params) {
    return api.get(`${apiUrl}/summary/bycategory`, { params: params })
  },
  getFilters(params) {
    return api.get(`${apiUrl}/filters/bycategory`, { params: params })
  },
  getDetail(edenPersonnelId) {
    return api.get(`${apiUrl}/detail?edenPersonnelId=${edenPersonnelId}`)
  },
  getEdenPersonnel(params) {
    return api.get(`${apiUrl}/edenpersonnel`, { params: params })
  },
  createEdenPersonnelReport(academicYearId) {
    return api.post(`${apiUrl}/createedenpersonnelreport/${academicYearId}`)
  },
  getPersonnelNames(params) {
    return api.get(`${apiUrl}/personnelnames`, { params: params })
  },
  updateEdenPersonnelReport(id) {
    return api.put(`${apiUrl}/updateedenpersonnelreport/${id}`)
  },
  submitReport(params) {
    return api.put(`${apiUrl}/submitmaster`, params)
  },
  deleteFiles(edenMasterId) {
    return api.delete(`${apiUrl}/files/delete/${edenMasterId}`)
  },
  getFiles(edenMasterId) {
    return api.get(`${apiUrl}/files/${edenMasterId}`)
  },
  getFile(edenFileId) {
    return api.get(`${apiUrl}/file/${edenFileId}`)
  },
  searchDetail(params) {
    return api.post(`${apiUrl}/searchdetail`, params)
  },
  generateFiles(id) {
    return api.post(`${apiUrl}/generatepersonnelfiles/${id}`)
  },
  amendReport(params) {
    return api.post(`${apiUrl}/amendReport`, params)
  },
  publishPublicPortalData(edenMasterId) {
    return api.post(`${apiUrl}/publishpublicportaldata/${edenMasterId}`)
  },
}
